import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import momenttz from 'moment-timezone';


@Pipe({
    name: 'datex'
})

export class DatexPipe implements PipeTransform {
    transform(value: any, format: string = ''): string {
        // Try and parse the passed value.
        // 2019-01-31
        // 2019-01-31T23:22:22
        // if ( value.indexOf( 'T' ) >= 0 ) {
        //     value = value.split( 'T' )[ 0 ];
        // }

        // if ( value.length === 10 ) {
        //     value += 'T12:00:00';
        // }
        const momentDate = momenttz.tz(value, 'Europe/Tallinn');



        // If moment didn't understand the value, return it unformatted.
        if (!momentDate.isValid()) {
            return value;
        }

        // Otherwise, return the date formatted as requested.
        return momentDate.format(format);
    }
}
